import gql from "@/api/gql.js"

const logInAuth = gql`
	query test_uatToken($tenantId: String!, $clientId: String!, $username: String!, $password: String!) {
		token_2(tenantId: $tenantId, clientId: $clientId, username: $username, password: $password) {
			accessToken
			refreshToken
			errorDescription
		}
	}
`

const query = {
	logInAuth
}

export { query }